import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { useT } from "../../contexts/LanguageContext";

const COLORS = { easy: "#059669", medium: "#D97706", hard: "#E11D48" };

export default function DifficultyDonut({ data }) {
  const { t, tDiff } = useT();
  const rows = (data || []).map((d) => ({
    name: tDiff(d.difficulty),
    value: d.count,
    key: d.difficulty,
  }));
  const total = rows.reduce((s, r) => s + r.value, 0);

  return (
    <div className="card lg:col-span-4" data-testid="difficulty-donut">
      <div className="overline">{t("analytics.donut_overline")}</div>
      <h3 className="font-display text-xl font-semibold mt-1">{t("analytics.donut_title")}</h3>
      <div className="h-52 mt-3 relative" style={{ minHeight: 200 }}>
        {total === 0 ? (
          <div className="h-full grid place-items-center text-slate-400 text-sm">{t("dash.no_history")}</div>
        ) : (
          <>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={rows}
                  innerRadius={55}
                  outerRadius={85}
                  dataKey="value"
                  paddingAngle={2}
                  stroke="#fff"
                  strokeWidth={2}
                >
                  {rows.map((r) => <Cell key={r.key} fill={COLORS[r.key]} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0F172A", border: "none", borderRadius: 6, color: "#fff", fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <div className="font-display text-3xl font-bold">{total}</div>
              <div className="overline mt-0.5">{t("common.questions")}</div>
            </div>
          </>
        )}
      </div>
      <div className="mt-3 flex justify-center gap-4 text-xs">
        {rows.map((r) => (
          <div key={r.key} className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: COLORS[r.key] }} />
            <span className="text-slate-600">{r.name}</span>
            <span className="font-mono font-bold">{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
